import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { cn } from "@/lib/utils";

interface RadioInputFieldProps extends FormFieldComponentProps {
  booleanValue?: boolean;
  options: { value: string; label: string }[];
  className?: string;
};

function RadioInputField(props: RadioInputFieldProps) {
  const { form, name, label, options, booleanValue, className } = props;

  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem className={cn("form-item space-y-3", className)}>
          {label && <FormLabel>{label}</FormLabel>}
          <FormControl>
            <RadioGroup
              onValueChange={
                booleanValue
                  ? (value) => field.onChange(value === "true")
                  : field.onChange
              }
              value={
                booleanValue
                  ? String(field.value ?? "")
                  : field.value ?? ""
              }
              className="flex flex-col space-y-1"
            >
              {options.map((option) => (
                <FormItem
                  key={option.value}
                  className="flex items-center space-x-3 space-y-0"
                >
                  <FormControl>
                    <RadioGroupItem value={option.value} />
                  </FormControl>
                  <FormLabel className="font-normal">
                    {option.label}
                  </FormLabel>
                </FormItem>
              ))}
            </RadioGroup>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}

export default RadioInputField;
